import { createSlice } from '@reduxjs/toolkit';
import _isNil from 'lodash/isNil';
import { RootState } from '@Services/redux/Store';
import { IAutomationTask } from './Interfaces';
import { initialAutomationTaskState } from './State';

const AutomationTaskSlice = createSlice({
    name: 'AutomationTask',
    initialState: initialAutomationTaskState,
    reducers: {
        reset() {
            return initialAutomationTaskState;
        },
        clearSelectedState(state) {
            state.selectedAutomationTaskUri = null;
        },
        updateAutomationTasks(state, action) {
            state.automationTaskOptions = action.payload;
        },
        setAutomationTasks(state, action) {
            state.automationTaskOptions = action.payload;
        },
        setSelectedAutomationTaskUri(state, action) {
            state.selectedAutomationTaskUri = action.payload;
        },
    },
});

export const AutomationTaskActions = AutomationTaskSlice.actions;

export const automationTasksState = (
    state: RootState
): Array<IAutomationTask> | null => state.automationTasks.automationTaskOptions;

export const selectedAutomationTaskUriState = (state: RootState) =>
    state.automationTasks.selectedAutomationTaskUri;

export default AutomationTaskSlice.reducer;
